import Model from './Model'

export default class Exercise extends Model {
  resource() {
    return 'exercise/videos'
  }
}
